import { configureStore } from "@reduxjs/toolkit";
import snackbarReducer from "./snackbarSlice";
import authReducer from "./authSlice";

export const store = configureStore({
  reducer: {
    snackbar: snackbarReducer,
    auth: authReducer, 
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;